import { NoDataContainer, NoDataImage, NoDataTitle } from "./grid.styles"

export const NoDataComponent = () => {
	return <NoDataContainer>
		<NoDataImage />
		<NoDataTitle>There's nothing here.</NoDataTitle>
	</NoDataContainer>
}